<div *ngIf="entradasTotales.entradasPendientes?.length > 0">
    <div class="card shadow-lg border-0 rounded-4 overflow-hidden h-100"
         style="background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px);">
        <div class="card-body">
            <h5 class="card-title text-secondary"><i class="mdi mdi-cart-outline"></i> Entradas Pendientes</h5>
            <div style="display: block; max-height: 400px; overflow-y: auto;"
                 class="pr-2">
                <div *ngFor="let entrada of entradasTotales.entradasPendientes"
                     class="mb-3">
                    <div class="d-flex justify-content-between mb-1">
                        <small class="text-truncate"
                               style="max-width: 70%;"
                               [title]="entrada.cliNombre"><strong>{{ entrada.cliNombre | uppercase }}</strong></small>
                        <small class="text-muted">{{ entrada.num_entradas }}</small>
                    </div>
                    <div class="progress"
                         style="height: 12px;">
                        <div class="progress-bar"
                             [ngClass]="entrada.colorClass"
                             role="progressbar"
                             [style.width.%]="(entrada.num_entradas / maxEntradas) * 100"
                             [attr.aria-valuenow]="entrada.num_entradas"
                             aria-valuemin="0"
                             [attr.aria-valuemax]="maxEntradas">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>